import {useState} from 'react';
import {SupportSlotDefinitionModel} from '../../../../model/support/slot/support-slot-definition.model';
import {SupportSlotDefinitionPageHooks} from './support-slot-definition-page-hooks';

export type SupportSlotDefinitionPageState = {
  slotDefinitions: SupportSlotDefinitionModel[]
  refreshSlotDefinitions: () => Promise<void>
  drawerOpen: boolean
  selectedWeekday: number | null
  setDrawerOpen: (value: boolean, weekday: number | null) => void

  selectedSlot: SupportSlotDefinitionModel | null
  slotPreviewDrawerOpen: boolean
  setSlotPreviewDrawerOpen: (value: boolean, slot: SupportSlotDefinitionModel | null) => void
}

export const useSupportSlotDefinitionPageState = (): SupportSlotDefinitionPageState => {
  const [drawerOpen, setDrawerOpen] = useState<boolean>(false)
  const [selectedWeekday, setSelectedWeekday] = useState<number | null>(null)

  const [slotPreviewDrawerOpen, setSlotPreviewDrawerOpen] = useState<boolean>(false);
  const [selectedSlot, setSelectedSlot] = useState<SupportSlotDefinitionModel | null>(null);

  const [slotDefinitions, setSlotDefinitions] = SupportSlotDefinitionPageHooks.useSupportSlotDefinitions()

  const refreshSlotDefinitions = async () => {
    setSlotDefinitions(await SupportSlotDefinitionPageHooks.fetchSupportSlotDefinitions())
  }

  return {
    selectedSlot: selectedSlot,
    slotPreviewDrawerOpen: slotPreviewDrawerOpen,
    setSlotPreviewDrawerOpen: (value, slot) => {
      setSelectedSlot(slot);
      setSlotPreviewDrawerOpen(value);
    },
    slotDefinitions: slotDefinitions,
    refreshSlotDefinitions: refreshSlotDefinitions,
    selectedWeekday: selectedWeekday,
    drawerOpen: drawerOpen,
    setDrawerOpen: (value, weekday) => {
      setSelectedWeekday(weekday)
      setDrawerOpen(value)
    }
  }
}
